import script from "./databox.vue?vue&type=script&setup=true&lang=js"
export * from "./databox.vue?vue&type=script&setup=true&lang=js"

import "./databox.vue?vue&type=style&index=0&id=32385105&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32385105"]])

export default __exports__